import React from 'react';

export default function LogoStandard() {
  return (
    <svg
      width="157"
      height="40"
      viewBox="0 0 157 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1736_2642)">
        <path
          d="M51.2769 27.4476C55.2296 27.4476 58.0493 25.3318 58.9053 21.9314L55.9597 21.3018C55.4058 23.5182 53.7441 24.8533 51.2769 24.8533C48.0291 24.8533 45.6122 22.6115 45.6122 18.4303C45.6122 14.2491 48.0543 11.9821 51.2769 11.9821C53.7189 11.9821 55.5065 13.4179 56.01 15.7856L58.9305 15.1559C58.301 11.6547 55.3554 9.41299 51.2769 9.41299C46.7703 9.41299 42.6162 12.4103 42.6162 18.4303C42.6162 24.4502 46.72 27.4476 51.2769 27.4476Z"
          fill="#161616"
        />
        <path
          d="M60.8652 27.2461H63.6094V21.7551C63.6094 18.657 64.8934 16.8182 67.0082 16.8182C68.7202 16.8182 69.7777 17.851 69.7777 19.5385V27.2461H72.5219V18.9089C72.5219 16.1381 70.6337 14.3499 67.7635 14.3499C65.976 14.3499 64.4906 15.1559 63.6094 16.7427V9.41299H60.8652V27.2461Z"
          fill="#161616"
        />
        <path
          d="M81.0065 27.4476C84.8082 27.4476 87.5524 24.7021 87.5524 20.8987C87.5524 17.0953 84.8082 14.3499 81.0065 14.3499C77.1797 14.3499 74.4607 17.0953 74.4607 20.8987C74.4607 24.7021 77.1797 27.4476 81.0065 27.4476ZM77.2301 20.8987C77.2301 18.4555 78.7406 16.7427 81.0065 16.7427C83.2472 16.7427 84.783 18.4555 84.783 20.8987C84.783 23.342 83.2472 25.0547 81.0065 25.0547C78.7406 25.0547 77.2301 23.342 77.2301 20.8987Z"
          fill="#161616"
        />
        <path
          d="M91.9919 27.2462H94.5095L97.2537 18.4051L99.9983 27.2462H102.541L106.443 14.5513L103.648 14.5513L101.257 23.4176L98.5375 14.5513H95.9949L93.2507 23.4176L90.859 14.5513H88.0645L91.9919 27.2462Z"
          fill="#161616"
        />
        <path
          d="M108.193 27.2461H110.987V14.2995L119.095 27.2461L122.191 27.2461V9.6145H119.372V22.5863L111.29 9.6145H108.193V27.2461Z"
          fill="#161616"
        />
        <path
          d="M130.815 27.4476C134.616 27.4476 137.36 24.7021 137.36 20.8987C137.36 17.0953 134.616 14.3499 130.815 14.3499C126.988 14.3499 124.269 17.0953 124.269 20.8987C124.269 24.7021 126.988 27.4476 130.815 27.4476ZM127.038 20.8987C127.038 18.4555 128.549 16.7427 130.815 16.7427C133.055 16.7427 134.591 18.4555 134.591 20.8987C134.591 23.342 133.055 25.0547 130.815 25.0547C128.549 25.0547 127.038 23.342 127.038 20.8987Z"
          fill="#161616"
        />
        <path
          d="M141.8 27.2462H144.318L147.062 18.4051L149.806 27.2462H152.349L156.251 14.5513L153.456 14.5513L151.065 23.4176L148.345 14.5513H145.803L143.059 23.4176L140.667 14.5513H137.872L141.8 27.2462Z"
          fill="#161616"
        />
        <g clipPath="url(#clip1_1736_2642)">
          <path
            d="M36 18.2626C36 8.45304 27.9388 0.5 18.0042 0.5C8.06122 0.5 0 8.45304 0 18.2626C0 18.5135 0.00847657 18.756 0.0169531 18.9986C0 19.7847 0.0847657 21.5408 0.91547 23.8573C1.66988 26.1069 2.86508 28.1558 4.40782 29.9037C6.86602 32.9226 10.672 36.1758 16.5802 39.1613C17.4702 39.6129 18.5298 39.6129 19.4198 39.1613C25.328 36.1674 29.1425 32.9226 31.5922 29.9037C33.1349 28.1558 34.3301 26.1069 35.0845 23.8573C35.9152 21.5492 36 19.7847 35.983 18.9986C35.9915 18.7477 36 18.5051 36 18.2626Z"
            fill="#161616"
          />
          <path
            d="M10.5976 10.276C11.1825 9.69901 12.1234 9.7241 12.6829 10.3179L16.4804 14.3822L14.8359 16.1467L10.6485 12.3333C10.0382 11.7897 10.0212 10.8531 10.5976 10.276Z"
            fill="white"
          />
          <path
            d="M27.7628 24.9277C27.8646 25.0197 28.0171 25.0197 28.1104 24.9277C28.1782 24.8524 28.1952 24.7521 28.1528 24.6768C28.1528 24.6768 27.1271 21.9506 25.72 20.5623C24.8554 19.7093 23.8212 19.2828 22.838 19.2661C21.8547 19.2494 21.3406 19.2661 20.3797 18.5636C19.9493 18.2489 19.4473 17.5684 19.4473 17.5684L25.186 12.3417C25.7878 11.7897 25.8132 10.8615 25.2283 10.2844C24.6435 9.70739 23.7026 9.73248 23.1431 10.3262C23.1431 10.3262 15.858 18.1578 15.3871 18.6222C14.9161 19.0865 13.8358 19.2912 12.8017 19.3079C11.7676 19.3246 10.6656 19.7762 9.75013 20.6794C8.03786 22.3687 7.10544 25.4964 8.48712 26.8595C9.86033 28.2227 13.0306 27.3028 14.7428 25.6135C15.6583 24.7103 16.116 23.389 16.133 22.3687C16.1499 21.3484 16.133 20.8676 16.7857 19.9602C17.1305 19.4808 17.9046 18.965 17.9046 18.965C17.9046 18.965 18.6313 19.5096 18.9642 19.9602C19.6847 20.9355 19.6677 21.407 19.6847 22.3687C19.7016 23.3304 20.1339 24.359 20.9985 25.2121C22.4057 26.6003 25.1775 27.6205 25.1775 27.6205C25.2707 27.6456 25.3724 27.6289 25.4403 27.562C25.5335 27.4617 25.5335 27.3111 25.4403 27.2191L21.4308 23.7235C21.185 23.4809 21.185 23.0963 21.4308 22.8537C21.6767 22.6112 22.0666 22.6112 22.3124 22.8537L26.2879 26.3828C26.4574 26.5501 26.7457 26.5501 26.9152 26.3828C27.0847 26.2156 27.0847 25.9313 26.9152 25.764L23.3381 21.8418C23.0923 21.5993 23.0923 21.2146 23.3381 20.9721C23.5839 20.7296 23.9738 20.7296 24.2196 20.9721L27.7628 24.9277Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1736_2642">
          <rect width="157" height="40" fill="white" />
        </clipPath>
        <clipPath id="clip1_1736_2642">
          <rect width="36" height="39" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
